import client from './client';

export const getIconsApi = data => client().get('/icons', { params: data });
